import { Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import React from "react";

const DomainInfoModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.domain? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			sx={{ margin: "auto", overflow: "auto" }}
		>
			<DialogTitle id="alert-dialog-title">
				{(props.domain)? props.domain.address : ""}
			</DialogTitle>
			<DialogContent sx={{ height: "100%", overflow: "auto" }}>
				{(props.domain)?
					<Stack direction="column" sx={{ overflow: "hidden", height: "100%", padding: "1em" }}>
						<Typography sx={{ marginBottom: "1em"}}>
							{`${props.domain.subdomains.length} Subdomains:`}
						</Typography>
						<div style={{ minHeight: "5em", maxHeight: "10em", width: "100%", overflowY: "scroll" }}>
							{props.domain.subdomains.map((subdomain, i) => {
								return (
									<Typography key={`subdomain_${i}`}>
										{subdomain}.{props.domain.address}
									</Typography>
								)
							})}
						</div>
					</Stack>
				: <React.Fragment/>}
			</DialogContent>
		</Dialog>
	);

}

export default DomainInfoModal;